<div class="row text-left">
  <div class="col-sm-12">
    <div class="content-header">Drag and Drop</div>
    <p class="content-sub-header">Simple angular drag and drop with dragula.</p>
  </div>
</div>
<!-- Drap and Drop Starts -->
<section id="dragndrop">




  <section id="spill-lists">
    <div class="row">

      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">Multiple Lists</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <p>Drag and drop items of more than one list. Add same group to group prop</p>
              <div class="row">
                <!-- Multiple (Group 1) starts -->
                <div class="col-md-6 col-12 mb-3 mb-md-0">
                  <h4 class="card-title mb-2">Group 1</h4>
                  <ul class="list-group" id="multiple-list-group-a" dragula="DRAGULA_FACTS">
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-12.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Mary S. Navarre</h5>
                          <span>Chupa chups tiramisu apple pie biscuit sweet roll bonbon macaroon.</span>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-1.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Max G. Ellis</h5>
                          <span>Toffee powder marzipan tiramisu. Cake cake dessert danish.</span>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-2.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Sandra C. Toney</h5>
                          <span>Sugar plum fruitcake gummies marzipan liquorice tiramisu.</span>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-3.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Samuel D. Goins</h5>
                          <span>Toffee powder marzipan tiramisu. Cake cake dessert danish.</span>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-4.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Linda M. English</h5>
                          <span>Chupa chups tiramisu apple pie biscuit sweet roll bonbon macaroon.</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- Multiple (Group 1) ends -->

                <!-- Multiple (Group 2) starts -->
                <div class="col-md-6 col-12">
                  <h4 class="card-title mb-2">Group 2</h4>
                  <ul class="list-group" id="multiple-list-group-b" dragula="DRAGULA_FACTS">
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-12.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Mary S. Navarre</h5>
                          <span>Chupa chups tiramisu apple pie biscuit sweet roll bonbon macaroon.</span>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-1.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Max G. Ellis</h5>
                          <span>Toffee powder marzipan tiramisu. Cake cake dessert danish.</span>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-2.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Sandra C. Toney</h5>
                          Sugar plum fruitcake gummies marzipan liquorice tiramisu
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-3.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Samuel D. Goins</h5>
                          <span>Toffee powder marzipan tiramisu. Cake cake dessert danish.</span>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-4.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Linda M. English</h5>
                          <span>Chupa chups tiramisu apple pie biscuit sweet roll bonbon macaroon.</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
                <!-- Multiple (Group 2) ends -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Spill section start -->

      <div class="col-12">
        <div class="card">

          <div class="card-header">
            <h4 class="card-title">Spill</h4>
          </div>
          <div class="card-content">
            <div class="card-body">
              <p>Need to be able to quickly delete stuff when it spills out of the chosen
                containers? Note how you
                can easily sort the items in any containers by just dragging and dropping.</p>
              <div class="row">
                <div class="col-6">
                  <ul class="list-group" dragula="SPILL">
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-12.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Mary S. Navarre</h5>
                          <span>Chupa chups tiramisu apple pie biscuit sweet roll bonbon macaroon toffee icing.</span>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-1.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Max G. Ellis</h5>
                          <span>Toffee powder marzipan tiramisu. Cake cake dessert danish.</span>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-2.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Sandra C. Toney</h5>
                          <span>Sugar plum fruitcake gummies marzipan liquorice tiramisu. Pastry liquorice chupa
                            chupsake</span>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-3.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Samuel D. Goins</h5>
                          <span>Toffee powder marzipan tiramisu. Cake cake dessert danish.</span>
                        </div>
                      </div>
                    </li>
                    <li class="list-group-item draggable">
                      <div class="media">
                        <img src="assets/img/portrait/small/avatar-s-4.png" class="rounded-circle mr-2"
                          alt="img-placeholder" height="50" width="50">
                        <div class="media-body">
                          <h5 class="mt-0">Linda M. English</h5>
                          <span>Chupa chups tiramisu apple pie biscuit sweet roll bonbon macaroon toffee icing.</span>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- // Spill section end -->
    </div>
  </section>

<!-- Clone List Starts -->
<section id="clone-lists">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Clone List</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>Clone list items from another existing list.</p>
            <div class="row">
              <!-- Badge source 1 starts -->
              <div class="col-md-6 col-12 mb-2 mb-md-0">
                <h6>Badge Source 1</h6>
                <div id="badge-list-1" dragula="COPYABLE">
                  <span class="badge badge-light draggable mb-1 mr-1">Google</span>
                  <span class="badge badge-primary draggable mb-1 mr-1">Facebook</span>
                  <span class="badge badge-success draggable mb-1 mr-1">Discord</span>
                  <span class="badge badge-danger draggable mb-1 mr-1">Youtube</span>
                  <span class="badge badge-info draggable mb-1 mr-1">Twitter</span>
                  <span class="badge badge-warning draggable mb-1 mr-1">Instagram</span>
                </div>
              </div>
              <!-- Badge source 1 ends -->

              <!-- Badge source 2 starts -->
              <div class="col-md-6 col-12">
                <h6>Badge Source 2</h6>
                <div id="badge-list-2" dragula="COPYABLE">
                  <span class="badge badge-light draggable mb-1 mr-1">Github</span>
                  <span class="badge badge-primary draggable mb-1 mr-1">Gitlab</span>
                  <span class="badge badge-success draggable mb-1 mr-1">Slack</span>
                  <span class="badge badge-danger draggable mb-1 mr-1">Pintrest</span>
                  <span class="badge badge-info draggable mb-1 mr-1">Tinder</span>
                  <span class="badge badge-warning draggable mb-1 mr-1">Amazon</span>
                </div>
              </div>
              <!-- Badge source 2 ends -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- // Clone List Ends -->

<!-- With Handle Starts -->
<section id="dd-with-handle">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">Drag and Drop with Handle</h4>
        </div>
        <div class="card-content">
          <div class="card-body">
            <p>You have to customize drag handle yourself using class <code>.handle</code></p>
            <div class="row">
              <div class="col-sm-6 mb-2 mb-sm-0">
                <h6 class="mb-2">List One</h6>
                <ul class="list-group" id="handle-list-1" dragula="HANDLES">
                  <li class="list-group-item"><span class="handle draggable-move">+</span>Cras justo odio</li>
                  <li class="list-group-item"><span class="handle draggable-move">+</span>Dapibus ac facilisis in</li>
                  <li class="list-group-item"><span class="handle draggable-move">+</span>Morbi leo risus</li>
                  <li class="list-group-item"><span class="handle draggable-move">+</span>Porta ac consectetur ac</li>
                  <li class="list-group-item"><span class="handle draggable-move">+</span>Vestibulum at eros</li>
                </ul>
              </div>
              <div class="col-sm-6">
                <h6 class="mb-2">List Two</h6>
                <ul class="list-group" id="handle-list-2" dragula="HANDLES">
                  <li class="list-group-item"><span class="handle draggable-move">+</span>Vestibulum at eros</li>
                  <li class="list-group-item"><span class="handle draggable-move">+</span>Porta ac consectetur ac</li>
                  <li class="list-group-item"><span class="handle draggable-move">+</span>Morbi leo risus</li>
                  <li class="list-group-item"><span class="handle draggable-move">+</span>Dapibus ac facilisis in</li>
                  <li class="list-group-item"><span class="handle draggable-move">+</span>Cras justo odio</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- // With Handle Ends -->

</section>
<!-- Drap and Drop Ends -->
